import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppLoader from "../../../components/AppLoader";
import StatusCard from "../../../components/Dashboard/StatusCard";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { getAdminDashbaordData } from "../../../services/dashboardApiFn";
import { handleOpenSnackBar } from "../../../utils";
import RecentClients from "./RecentClients";
import RecentCompanies from "./RecentCompanies";
import RecentSuppliers from "./RecentSuppliers";
import RecentWorkers from "./RecentWorkers";
import TopSaleProducts from "./TopProducts";
import TopServices from "./TopServices";
import TopWorkers from "./TopWorkers";

function AdminDashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const userData = useSelector((state) => state.userData.user);

  const getDashboardData = async () => {
    try {
      setIsLoading(true);
      const response = await getAdminDashbaordData(userData.adminId);
      if (response?.data?.status === "success") {
        let data = response?.data?.data;
        setDashboardData(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!userData) return
    getDashboardData();
  }, [userData]);

  const cardData = [
    {
      primary: "totalCustomers",
      secondary: "registered",
      value: dashboardData?.totalUsers || 0,
    },
    {
      primary: "totalCompanies",
      secondary: "registered",
      value: dashboardData?.totalCompanies || 0,
    },
    {
      primary: "totalWorkers",
      secondary: "registered",
      value: dashboardData?.totalWorkers || 0,
    },
    {
      primary: "totalSuppliers",
      secondary: "registered",
      value: dashboardData?.totalSuppliers || 0,
    },
    {
      primary: "totalServices",
      secondary: "weAreProviding",
      value: dashboardData?.totalServices || 0,
    },
  ];

  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading} />

      <Grid container spacing={2}>
        {cardData.map((vall) => {
          return <StatusCard item={vall} />;
        })}

        <Grid item xs={12} md={6}>
          <RecentClients
            tableData={dashboardData?.recentUsers || []}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <RecentCompanies
            tableData={dashboardData?.recentCompanies || []}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <RecentWorkers
            tableData={dashboardData?.recentWorkers || []}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <RecentSuppliers
            tableData={dashboardData?.recentSuppliers || []}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TopSaleProducts
            tableData={dashboardData?.topProducts || []}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TopServices
            tableData={dashboardData?.topServices || []}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TopWorkers
            tableData={dashboardData?.topWorkers || []}
            isLoading={isLoading}
          />
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default AdminDashboard;
